export const userConstants = {
    CREATE_USER: 'CREATE_USER',
    CHANGE_NAME: 'CHANGE_NAME',
    CHANGE_PIC: 'CHANGE_PIC',
}